import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const TagValueContext = createContext<typeof initialState>(initialState);

const TagActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { TagActionContext, TagValueContext };
